import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Input,
  output,
  Output,
  Signal,
  viewChild,
} from "@angular/core";
import { UserInfos } from "app/features/user_infos/models/user_infos.model";
import { UiFacadeService } from "../../../features/user_infos/services/store/ui-facade.service";
import { DatePipe } from "@angular/common";
import { BigButtonComponent } from "../big-button/big-button.component";
import { AuthService } from "../../../features/auth/services/auth.service";
import { Router } from "@angular/router";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { DocLocalComponent } from "../../../features/documents/containers/doc-local/doc-local.component";
import { DialogsService } from "../../services/dialogs/dialogs.service";
import { HeaderDialogComponent } from "../../modules/dialog/header-dialog/header-dialog.component";
import { RecordButtonsComponent } from "../../../features/logs/record-buttons/record-buttons.component";
import { ChipsComponent } from "../../modules/chips/chips.component";
import { TicketService } from "../../../features/logs/services/ticket.service";
import { SharedModule } from "../../shared.module";

@Component({
  selector: "vl-user-info-card",
  templateUrl: "./user-info-card.component.html",
  styleUrls: ["./user-info-card.component.scss"],
  standalone: true,
  imports: [
    DatePipe,
    BigButtonComponent,
    MatMenuModule,
    DocLocalComponent,
    HeaderDialogComponent,
    RecordButtonsComponent,
    ChipsComponent,
    SharedModule,
  ],
})
export class UserInfoCardComponent {
  uiFacade = inject(UiFacadeService);
  dialogService = inject(DialogsService);
  ticketService = inject(TicketService);

  userInfosId = input<string>();
  userId = input<string>();
  inline = input<boolean>(false);
  white = input<boolean>(false);
  hideNameOnMobile = input<boolean>(false);
  size = input<"normal" | "small">("normal");
  deactivateVisu = input(false);
  darkMode = input<boolean>(false);

  toggleDarkMode = output();

  menuTrigger: Signal<MatMenuTrigger> = viewChild("menuTrigger");

  imageSize = computed(() => {
    if (this.size() === "normal") {
      return "32px";
    }
    if (this.size() === "small") {
      return "24px";
    }
  });

  fontTitle = computed(() => {
    if (this.size() === "normal") {
      return "body-2";
    }
    if (this.size() === "small") {
      return "caption-2";
    }
  });

  fontSubtitle = computed(() => {
    if (this.size() === "normal") {
      return "caption";
    }
    if (this.size() === "small") {
      return "tiny";
    }
  });

  userInfos = computed(() => {
    if (this.userInfosId()) {
      return this.uiFacade.getById(this.userInfosId())();
    } else if (this.userId()) {
      return this.uiFacade.getByUserId(this.userId())();
    }
  });
  initials = computed(() => {
    return `${this.userInfos()?.prenom?.slice(0, 1)}${this.userInfos()?.nom?.slice(0, 1)}`.toUpperCase();
  });
  bgColor = computed(() => {
    if (this.userInfos()) {
      return this.getColor(this.userInfos()?.id);
    }
  });
  textColor = computed(() => {
    if (this.bgColor()) {
      return this.getTextColor(this.bgColor());
    }
  });

  @Input() menu = false;
  @Input() width?: string;
  @Input() date: Date;
  @Input() selected: UserInfos;
  @Input() bulle: boolean = false;
  @Output() select = new EventEmitter<UserInfos>();

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  getColor(uuid) {
    let hashValue = this.hash(uuid);
    const colorCode = Math.abs(hashValue) % 0x1000000;
    const hexColor = colorCode.toString(16).padStart(6, "0"); // Convert to hex and pad with zeros if needed
    return `#${hexColor}`;
  }

  hash(uuid) {
    const x = uuid.split("-").reduce((a, b) => a ^ Number.parseInt(b, 16), 271);
    return arguments.length === 1 ? x : x % 256;
  }

  getTextColor(backgroundColor: string) {
    const rgb = this.hexToRgb(backgroundColor);
    const brightness = Math.round(
      (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000,
    );
    return brightness > 125 ? "black" : "white";
  }

  hexToRgb(hex: string) {
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  openMenu() {
    if (!this.menu) {
      return;
    }

    this.menuTrigger().openMenu();
  }

  goProfile() {
    this.router.navigate([
      "/profile/userId/" + this.authService.userSignal().id + "/infos",
    ]);
  }

  onLogout() {
    this.authService.logout();
  }
}
